import { createAsyncThunk } from '@reduxjs/toolkit';

import { type AffiliateRootState } from '..';
import { type Plan } from '@/utils/mapProductObject';

interface SelectedPlanPayload {
  plan: Plan;
  isProfileLoaded: boolean;
}

// switches to payment methods step and selects a plan
export const selectPlanAndProceed = createAsyncThunk<SelectedPlanPayload, Plan, { state: AffiliateRootState }>(
  'selectAffiliatePlanAndProceed',
  (arg, thunkApi) => {
    return {
      plan: arg,
      isProfileLoaded: thunkApi.getState().user.profile !== undefined,
    };
  },
);
